import { useFetcher } from "@remix-run/react";
import { useEffect, useState } from "react";

const REFRESH_INTERVAL = 30 * 1000; // 30 seconds

export const useAppVersion = () => {
  const [initialRemixBackendServerVersion, setInitialRemixBackendServerVersion] = useState<string | null>(null);
  const [newVersionAvailableFromRemixBackend, setNewVersionAvailableFromRemixBackend] = useState(false);
  const fetcher = useFetcher<{ version: string }>();
  const fetchedRemixBackendServerVersion = fetcher.data?.version;

  useEffect(() => {
    // Need to use a useEffect to ensure the code runs on the client side on first render.
    setInitialRemixBackendServerVersion((window as any).APP_VERSION);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetcher.load("/app_version");
    }, REFRESH_INTERVAL);

    return () => clearInterval(interval);
  }, [fetcher]);

  useEffect(() => {
    if (fetcher.state !== "idle") return;

    const clientVersion = (window as any).APP_VERSION;
    const remixBackendServerVersion = fetchedRemixBackendServerVersion || initialRemixBackendServerVersion;

    if (clientVersion && remixBackendServerVersion && clientVersion !== remixBackendServerVersion) {
      setNewVersionAvailableFromRemixBackend(true);
    }
  }, [initialRemixBackendServerVersion, fetchedRemixBackendServerVersion, fetcher.state]);

  useEffect(() => {
    if (newVersionAvailableFromRemixBackend) {
      setTimeout(() => {
        window.location.reload();
      }, 10 * 1000);
    }
  }, [newVersionAvailableFromRemixBackend]);

  return { newVersionAvailableFromRemixBackend };
};
